import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { loginUser, receiveToken, doInit } from '../../../actions/auth';
import {
  Container,
  Button,
  FormGroup,
  FormText,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import Footer from '../../../components/Footer/Footer';
import TulufaliLogo from '../../../components/Icons/tulufali_logo.png';
import GoogleIcon from '../../../components/Icons/AuthIcons/GoogleIcon.js';
import { loginSmart } from '../../../actions/auth';
import { validateEmail, validatePassword } from '../../../utils/func';
import Map from '../../../components/am4chartMap/am4chartMap.js';
import MapDesil from '../../../components/am4chartMap/am4chartMapDesil.js';
import CariIndividu from '../../tables/CariIndividu.js';
import CardBantuan from '../../../components/landing/CardBantuan.js';
import GrafikDanaTahunan from '../../../components/landing/GrafikDanaTahunan.js';
import RekapanDtsenKecamatan from '../../../components/landing/RekapanDtsenKecamatan.js';
import s from './Login.module.scss';
import 'eva-icons/style/eva-icons.css';

const currentYear = new Date().getFullYear();
const listTahun = Array.from(
  { length: currentYear - 2018 + 1 },
  (_, i) => String(2018 + i)
).reverse();

const Login = (props) => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [idSmart, setIdSmart] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginProses, setLoginProses] = useState(false);
  const [activeTab, setActiveTab] = useState('petaDesil');
  const [tahunMap, setTahunMap] = useState(String(currentYear));
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [headerCompact, setHeaderCompact] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 1240 : false
  );
  const landingHeaderRef = useRef(null);
  const headerBrandRef = useRef(null);
  const headerMenuRef = useRef(null);
  const headerActionsRef = useRef(null);

  useLayoutEffect(() => {
    const HEADER_COMPACT_MAX_CSS = 1240;

    const measureMenuFullWidth = () => {
      const nav = headerMenuRef.current;
      if (!nav) return 0;
      nav.classList.add(s.headerMenuMeasure);
      const w = nav.scrollWidth;
      nav.classList.remove(s.headerMenuMeasure);
      return w;
    };

    const updateCompact = () => {
      const header = landingHeaderRef.current;
      const brand = headerBrandRef.current;
      const actions = headerActionsRef.current;
      if (!header || !brand || !actions) return;

      const narrowViewport = window.innerWidth <= HEADER_COMPACT_MAX_CSS;
      if (narrowViewport) {
        setHeaderCompact(true);
        return;
      }

      const menuFullW = measureMenuFullWidth();
      const gapsPadding = 80;
      const available =
        header.clientWidth -
        brand.offsetWidth -
        actions.offsetWidth -
        gapsPadding;
      setHeaderCompact(menuFullW > available);
    };

    updateCompact();
    const ro =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(() => updateCompact())
        : null;
    if (ro && landingHeaderRef.current) {
      ro.observe(landingHeaderRef.current);
    }
    window.addEventListener('resize', updateCompact);
    return () => {
      window.removeEventListener('resize', updateCompact);
      if (ro) ro.disconnect();
    };
  }, []);

  useEffect(() => {
    const el = document.getElementById('myInput');
    if (el && el.value) setIdSmart(el.value);
  }, []);

  const loginSmartKu = (e) => {
    setLoginProses(true);
    const el = document.getElementById('myInput');
    const uid = el ? el.value : '';
    props.dispatch(loginSmart(uid, setLoginProses));
  };

  const doLogin = (e) => {
    setLoginProses(true);
    e.preventDefault();
    if (passwordError || emailError) {
      alert('Password dan Email harus sesuai standar');
      setLoginProses(false);
      return;
    }
    const redirectTo = props.location?.state?.from || props.from;
    props.dispatch(
      loginUser({ password, email }, setLoginProses, redirectTo)
    );
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const token = params.get('token');
    if (token) {
      props.dispatch(receiveToken(token));
      props.dispatch(doInit());
    }
  });

  if (props.isAuthenticated) {
    const from = props.location?.state?.from || props.from || { pathname: '/template/dashboard' };
    return <Redirect to={from} />;
  }

  const tabs = [
    { id: 'petaDesil', label: 'Peta DTSEN' },
    { id: 'peta', label: 'Peta Distribusi Bantuan' },
    { id: 'cari', label: 'Cari DTSEN' },
    { id: 'rekapanKec', label: 'Rekapan DTSEN Per Kecamatan' },
    { id: 'cardBantuan', label: 'Card Bantuan' },
    { id: 'grafik', label: 'Grafik' },
  ];

  return (
    <div className="auth-page">
      <div className={s.landingPage}>
        <header
          ref={landingHeaderRef}
          className={`${s.landingHeader} ${headerCompact ? s.landingHeaderCompact : ''}`}
        >
          <div ref={headerBrandRef} className={s.headerBrand}>
            <img src={TulufaliLogo} alt="Tulu Fali" className={s.headerLogo} />
            <h1 className={s.headerTitle}>Tulu Fali 2.0</h1>
          </div>
          <nav ref={headerMenuRef} className={s.headerMenu} aria-hidden={headerCompact}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`${s.headerMenuItem} ${activeTab === tab.id ? s.active : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
          <div ref={headerActionsRef} className={s.headerActions}>
            <Dropdown isOpen={menuOpen} toggle={() => setMenuOpen(!menuOpen)} className={s.headerMenuDropdown}>
              <DropdownToggle tag="button" className={s.headerMenuBtn} aria-label="Menu">
                <i className="eva eva-menu-outline" />
              </DropdownToggle>
              <DropdownMenu right className={s.headerDropdownMenu}>
                {tabs.map((tab) => (
                  <DropdownItem
                    key={tab.id}
                    className={activeTab === tab.id ? s.menuItemActive : ''}
                    onClick={() => {
                      setActiveTab(tab.id);
                      setMenuOpen(false);
                    }}
                  >
                    {tab.label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            <button
              type="button"
              className={s.headerLoginBtn}
              onClick={() => setLoginModalOpen(true)}
            >
              Login
            </button>
          </div>
        </header>

        <Modal isOpen={loginModalOpen} toggle={() => setLoginModalOpen(false)} className={s.loginModal} size="md">
          <ModalHeader toggle={() => setLoginModalOpen(false)}>Login Admin</ModalHeader>
          <ModalBody>
            <form onSubmit={(e) => doLogin(e)}>
              {idSmart ? (
                <div className="d-flex justify-content-center py-3">
                  <Button
                    className="rounded-pill"
                    onClick={() => loginSmartKu()}
                    color="primary"
                    disabled={loginProses}
                  >
                    Login dengan Akun RSS
                  </Button>
                </div>
              ) : (
                <>
                  <FormGroup>
                    <FormText>Email</FormText>
                    {emailError && <span className="text-danger small d-block">{emailError}</span>}
                    <Input
                      id="email"
                      value={email}
                      onChange={(e) => {
                        validateEmail(e.target.value, setEmailError);
                        setEmail(e.target.value);
                      }}
                      type="email"
                      style={{ borderColor: emailError ? 'red' : 'initial' }}
                      required
                      placeholder="Email (username smartservice)"
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className="d-flex justify-content-between">
                      <FormText>Password</FormText>
                      <Link to="#" onClick={(e) => e.preventDefault()}>Forgot password?</Link>
                    </div>
                    {passwordError && <span className="text-danger small d-block">{passwordError}</span>}
                    <Input
                      id="password"
                      value={password}
                      onChange={(e) => {
                        validatePassword(e.target.value, setPasswordError);
                        setPassword(e.target.value);
                      }}
                      type="password"
                      style={{ borderColor: passwordError ? 'red' : 'initial' }}
                      required
                      placeholder="Password"
                    />
                  </FormGroup>
                  <div className="d-flex justify-content-center mt-4">
                    {loginProses ? (
                      <Button type="submit" color="primary" disabled>
                        <Spinner size="sm" color="light" className="mr-2" /> Login ...
                      </Button>
                    ) : (
                      <Button type="submit" color="primary" disabled={loginProses}>
                        Login
                      </Button>
                    )}
                  </div>
                  <p className={s.dividingLine}>&#8195;Atau&#8195;</p>
                  <div className={s.socialBlock}>
                    <p className={s.socialLabel}>Download Rote Smart Service</p>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.rotesmartservice"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <GoogleIcon />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.rotesmartservice"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`d-block mt-2 ${s.rssLink}`}
                    >
                      Segera buat akun Rote Smart Service
                    </a>
                  </div>
                </>
              )}
            </form>
          </ModalBody>
        </Modal>

        <div className={s.landingBanner}>
          <img
            src={`${process.env.PUBLIC_URL || ''}/banner_tulufali.png`}
            alt="Tulu Fali - Sistem Terintegrasi Bantuan dan Hibah"
            className={s.bannerImage}
          />
        </div>

        <div className={s.heroSection}>
          <h2 className={s.heroTitle}>Data Bantuan Sosial Terintegrasi Kabupaten Rote Ndao</h2>
          <p className={s.heroSubtitle}>
            Menajemen Bantuan Sosial dan Hibah terpadu — untuk penanggulangan kemiskinan.
          </p>
        </div>

        <div className={s.landingMain}>
        <Container className={`col-12 ${s.landingContainer}`}>
          <div className={s.tabsWrap}>
            <h3 className={s.tabsSectionTitle}>Akses Data</h3>
            <div className={s.tabPane}>
              {activeTab === 'peta' && (
                <>
                  <div className={s.mapYearRow}>
                    <span className={s.mapYearLabel}>Tahun:</span>
                    <UncontrolledDropdown>
                      <DropdownToggle caret color="primary">
                        {tahunMap}
                      </DropdownToggle>
                      <DropdownMenu>
                        {listTahun.map((t) => (
                          <DropdownItem
                            key={t}
                            onClick={() => setTahunMap(String(t))}
                          >
                            {t}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                  <Map tahun={tahunMap} />
                </>
              )}
              {activeTab === 'cari' && <CariIndividu landingPublicMode />}
              {activeTab === 'petaDesil' && <MapDesil />}
              {activeTab === 'rekapanKec' && <RekapanDtsenKecamatan />}
              {activeTab === 'cardBantuan' && <CardBantuan />}
              {activeTab === 'grafik' && <GrafikDanaTahunan />}
            </div>
          </div>
        </Container>
        </div>
        <div className={s.landingFooter}>
          <Footer centered />
        </div>
      </div>
    </div>
  );
};

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  location: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    isFetching: state.auth.isFetching,
    isAuthenticated: state.auth.isAuthenticated,
    errorMessage: state.auth.errorMessage,
  };
}

export default withRouter(connect(mapStateToProps)(Login));
